// import { useEffect, useState } from "react";

// // interface UserRow {
// //   id: string;
// //   firstName: string;
// //   lastName: string;
// //   email: string;
// //   role: string;
// //   lastLogin: string | null;
// //   prospectCount: number;
// //   pdfCount: number;
// //   lastPdfUrl?: string;
// // }\
// interface UserRow {
//   id: string;
//   firstName: string;
//   lastName: string;
//   email: string;
//   role: string;
//   lastLogin: string | null;

//   prospectTotal: number;
//   prospectThisYear: number;
//   prospectThisMonth: number; 
//   prospectLastMonth: number;

//   pdfGenerated: number;
//   pdfSent: number;
// }

// export default function AdminUserTable() {
//   const [users, setUsers] = useState<UserRow[]>([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetch("/api/admin/users-activity", { credentials: "include" })
//       .then((r) => r.json())
//       .then((res) => {
//         const rows: UserRow[] = (res.data || []).map((u: any) => {
//           const name = String(u.name || "").trim();
//           const [firstName = "", ...rest] = name.split(" ");
//           const lastName = rest.join(" ");

//           return {
//             id: String(u.id),

//             firstName: firstName || "—",
//             lastName: lastName || "",

//             // ✅ REAL DATA FROM BACKEND
//             email: u.email || "—",
//             role: u.role || "user",

//             lastLogin: u.lastLogin || null,
//             // prospectCount: Number(u.prospectCount || 0),
//             // pdfCount: Number(u.pdfCount || 0),
//             prospectTotal: Number(u.prospectTotal || 0),
//             prospectThisYear: Number(u.prospectThisYear || 0),
//             prospectThisMonth: Number(u.prospectThisMonth || 0),
//             prospectLastMonth: Number(u.prospectLastMonth || 0),

//             pdfGenerated: Number(u.pdfGenerated || 0),
//             pdfSent: Number(u.pdfSent || 0),

//             lastPdfUrl: undefined,
//           };
//         });

//         setUsers(rows);
//       })
//       .catch(() => {
//         setUsers([]);
//       })
//       .finally(() => setLoading(false));
//   }, []);

//   if (loading) {
//     return <div className="p-6 text-gray-500">Loading users...</div>;
//   }

//   return (
//     <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
//       <h1 className="text-2xl font-semibold mb-6">User Management</h1>

//       <div className="overflow-x-auto rounded-xl border bg-white shadow-sm">
//         <table className="min-w-full text-sm">
//           <thead className="bg-slate-800 text-white">
//             <tr>
//               <th className="px-4 py-3 text-left">Full Name</th>
//               <th className="px-4 py-3 text-left">Email</th>
//               <th className="px-4 py-3 text-left">Role</th>
//               <th className="px-4 py-3 text-center">Last Login</th>
//               {/* <th className="px-4 py-3 text-center">Prospects</th>
//               <th className="px-4 py-3 text-center">PDFs</th> */}
//               <th>Total Prospects</th>
//               <th>This Year</th>
//               <th>Last Month</th>
//               <th>This Month</th> 
//               <th>PDF Generated</th>
//               <th>PDF Sent</th>
//               {/* <th className="px-4 py-3 text-center">Last PDF</th> */}
//               <th className="px-4 py-3 text-center">Actions</th>
//             </tr>
//           </thead>

//           <tbody className="divide-y">
//             {users.map((u) => (
//               <tr key={u.id} className="hover:bg-gray-50">
//                 <td className="px-4 py-3 font-medium">
//                   {u.firstName} {u.lastName}
//                 </td>

//                 <td className="px-4 py-3">{u.email}</td>

//                 <td className="px-4 py-3">
//                   <span className="rounded-full bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700">
//                     {u.role}
//                   </span>
//                 </td>

//                 <td className="px-4 py-3 text-center text-gray-600">
//                   {u.lastLogin ? new Date(u.lastLogin).toLocaleString() : "—"}
//                 </td>

//                 {/* <td className="px-4 py-3 text-center">
//                   {u.prospectCount}
//                 </td>

//                 <td className="px-4 py-3 text-center">
//                   {u.pdfCount}
//                 </td> */}
//                 <td>{u.prospectTotal}</td>
//                 <td>{u.prospectThisYear}</td>
//                 <td>{u.prospectThisMonth}</td>
//                 <td>{u.prospectLastMonth}</td>
//                 <td>{u.pdfGenerated}</td>
//                 <td>{u.pdfSent}</td>

//                 {/* <td className="px-4 py-3 text-center">
//                   {u.lastPdfUrl ? (
//                     <a
//                       href={u.lastPdfUrl}
//                       target="_blank"
//                       rel="noreferrer"
//                       className="text-blue-600 underline"
//                     >
//                       View
//                     </a>
//                   ) : (
//                     "—"
//                   )}
//                 </td> */}

//                 <td className="px-4 py-3 text-center">
//                   <button
//                     className="text-sm text-indigo-600 hover:underline"
//                     onClick={() =>
//                       fetch(`/api/admin/reset-2fa/${u.id}`, {
//                         method: "POST",
//                         credentials: "include",
//                       })
//                     }
//                   >
//                     Reset 2FA
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {users.length === 0 && (
//           <div className="p-6 text-center text-gray-500">
//             No user activity found
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }



import { useEffect, useState } from "react";

interface UserRow {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  lastLogin: string | null;

  prospectTotal: number;
  prospectThisYear: number;
  prospectThisMonth: number;
  prospectLastMonth: number;

  pdfGenerated: number;
  pdfSent: number;
}

export default function AdminUserTable() {
  const [users, setUsers] = useState<UserRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/admin/users-activity", { credentials: "include" })
      .then((r) => r.json())
      .then((res) => {
        const rows: UserRow[] = (res.data || []).map((u: any) => {
          const name = String(u.name || "").trim();
          const [firstName = "", ...rest] = name.split(" ");
          const lastName = rest.join(" ");

          return {
            id: String(u.id),
            firstName: firstName || "—",
            lastName: lastName || "",
            email: u.email || "—",
            role: u.role || "user",
            lastLogin: u.lastLogin || null,

            prospectTotal: Number(u.prospectTotal || 0),
            prospectThisYear: Number(u.prospectThisYear || 0),
            prospectThisMonth: Number(u.prospectThisMonth || 0),
            prospectLastMonth: Number(u.prospectLastMonth || 0),

            pdfGenerated: Number(u.pdfGenerated || 0),
            pdfSent: Number(u.pdfSent || 0),
          };
        });

        setUsers(rows);
      })
      .catch(() => setUsers([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="page-shell text-gray-500">Loading users...</div>;
  }

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      <h1 className="mb-6 text-2xl font-bold text-gray-900">User Management</h1>

      <div className="table-responsive rounded-xl border bg-white shadow-sm">
        <table className="min-w-full text-sm border-collapse">
          <thead className="bg-slate-800 text-white">
            <tr className="divide-x divide-slate-600">
              <th className="px-4 py-3 text-left">User</th>
              <th className="px-4 py-3 text-left">Email</th>
              <th className="px-4 py-3 text-left">Role</th>
              <th className="px-4 py-3 text-center">Last Login</th>

              {/* PROSPECTS */}
              <th className="px-3 py-3 text-center bg-slate-700">Total(con)</th>
              <th className="px-3 py-3 text-center bg-slate-700">This Year (con)</th>
              <th className="px-3 py-3 text-center bg-slate-700">This Month (con)</th>
              <th className="px-3 py-3 text-center bg-slate-700">Last Month (con)</th>

              {/* PDF */}
              <th className="px-3 py-3 text-center bg-slate-600">
                PDF Generated
              </th>
              <th className="px-3 py-3 text-center bg-slate-600">
                PDF Sent
              </th>

              <th className="px-4 py-3 text-center">Actions</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">
            {users.map((u) => (
              <tr
                key={u.id}
                className="hover:bg-gray-50 transition-colors divide-x"
              >
                <td className="px-4 py-3 font-medium">
                  {u.firstName} {u.lastName}
                </td>

                <td className="px-4 py-3 text-gray-700">{u.email}</td>

                <td className="px-4 py-3">
                  <span className="inline-flex rounded-full bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700">
                    {u.role}
                  </span>
                </td>

                <td className="px-4 py-3 text-center text-gray-600">
                  {u.lastLogin
                    ? new Date(u.lastLogin).toLocaleString()
                    : "—"}
                </td>

                {/* PROSPECTS */}
                <td className="px-3 py-3 text-center font-semibold">
                  {u.prospectTotal}
                </td>
                <td className="px-3 py-3 text-center">
                  {u.prospectThisYear}
                </td>
                <td className="px-3 py-3 text-center">
                  {u.prospectThisMonth}
                </td>
                <td className="px-3 py-3 text-center">
                  {u.prospectLastMonth}
                </td>

                {/* PDF */}
                <td className="px-3 py-3 text-center">
                  {u.pdfGenerated}
                </td>
                <td className="px-3 py-3 text-center">
                  {u.pdfSent}
                </td>

                <td className="px-4 py-3 text-center">
                  <button
                    className="text-sm text-indigo-600 hover:underline"
                    onClick={() =>
                      fetch(`/api/admin/reset-2fa/${u.id}`, {
                        method: "POST",
                        credentials: "include",
                      })
                    }
                  >
                    Reset 2FA
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {users.length === 0 && (
          <div className="p-6 text-center text-gray-500">
            No user activity found
          </div>
        )}
      </div>
    </div>
  );
}
